import React, { useState } from "react";
import { ITreatment, ISubTreatment } from "../types/clinic.types";
import { ConfirmationModal } from "./ConfirmationModal";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
interface Props {
  treatment: ITreatment;
  onDelete: () => void;
  onEdit: () => void;
  onAddSub: () => void;
  onEditSub: (sub: ISubTreatment) => void;
  onDeleteSub: (subId: string) => void;
}

export const TreatmentCard: React.FC<Props> = ({
  treatment,
  onDelete,
  onEdit,
  onAddSub,
  onEditSub,
  onDeleteSub,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [subDeleteCandidate, setSubDeleteCandidate] = useState<string | null>(
    null
  );

  const handleDeleteConfirm = () => {
    if (subDeleteCandidate) {
      onDeleteSub(subDeleteCandidate);
      setSubDeleteCandidate(null);
    }
  };

  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden">
      <header
        className="px-3 py-2 bg-slate-50 flex justify-between items-center cursor-pointer hover:bg-slate-100 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h4 className="text-xs font-semibold text-slate-800 mb-0">{treatment.name} - {treatment.description}</h4>
        <div className="flex items-center gap-1.5">
          <button
            className="p-1.5 text-slate-600 hover:text-primary hover:bg-slate-200 rounded-md transition-colors"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            <EditIcon sx={{ fontSize: 16 }} />
          </button>
          {isExpanded ? <ExpandMoreIcon className="text-slate-600" sx={{ fontSize: 16 }} /> : <ExpandLessIcon className="text-slate-600" sx={{ fontSize: 16 }} />}
        </div>
      </header>

      {isExpanded && (
        <div className="p-3 border-t border-slate-200">
          <p className="text-xs text-slate-600 mb-3">{treatment.description}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 mt-2.5">
            <div className="p-2.5 bg-slate-50 rounded-lg">
              <strong className="text-xs text-slate-800">Consulting Local Price:</strong> <span className="text-xs text-slate-700">{treatment.localPrice}</span>{" "}
              <strong className="text-xs text-slate-600">
                <i>LKR</i>
              </strong>
            </div>
            <div className="p-2.5 bg-slate-50 rounded-lg">
              <strong className="text-xs text-slate-800">Consulting Foreigner Price:</strong>{" "}
              <span className="text-xs text-slate-700">{treatment.foreginPrice}</span>{" "}
              <strong className="text-xs text-slate-600">
                <i>USD</i>
              </strong>
            </div>
          </div>

          <div className="mt-3 pt-3 border-t border-dashed border-slate-200">
            <h5 className="font-semibold text-xs text-slate-700 mb-2.5">Sub-Treatments</h5>
            {treatment.subTreatments.length === 0 ? (
              <p className="text-xs text-slate-500">No sub-treatments.</p>
            ) : (
              treatment.subTreatments.map((sub,i) => (
                <div key={i} className="flex justify-between items-start py-2 border-b border-slate-100 last:border-b-0">
                  <div className="flex-1">
                    <strong className="block text-xs text-slate-800 mb-1">{sub.description}</strong>
                    <span className="text-[10px] text-slate-600 block">
                      Local: {sub.localPrice} LKR min {sub.minlocalPrice} LKR - max{" "}
                      {sub.maxlocalPrice} LKR{" "}
                    </span>
                    <span className="text-[10px] text-slate-600 block">
                      Foreigner: {sub.foreignerPrice} USD min{" "}
                      {sub.minforeignerPrice} USD - max {sub.maxforeignerPrice} USD
                    </span>
                    <span className="text-[10px] text-slate-600 block">Description: {sub.description}</span>
                    <span className="text-[10px] text-slate-600 block">Note: {sub.note}</span>
                  </div>
                  <div className="flex items-center gap-1.5 ml-3">
                    <button
                      className="p-1.5 text-slate-600 hover:text-primary hover:bg-slate-100 rounded-md transition-colors"
                      onClick={() => onEditSub(sub)}
                    >
                      <EditIcon sx={{ fontSize: 14 }} />
                    </button>
                    <button
                      className="p-1.5 text-slate-600 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
                      onClick={() => setSubDeleteCandidate(sub?.id)}
                    >
                      <DeleteIcon sx={{ fontSize: 14 }} />
                    </button>
                  </div>
                </div>
              ))
            )}
            <button
              className="flex items-center gap-1.5 px-4 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium hover:shadow-lg hover:shadow-primary/20 transition-all mt-3 text-xs"
              onClick={onAddSub}
            >
              <AddIcon sx={{ fontSize: 16 }} />
              Add Sub-Treatment
            </button>
          </div>
        </div>
      )}

      {subDeleteCandidate && (
        <ConfirmationModal
          title="Delete Sub-Treatment"
          message="Are you sure you want to delete this sub-treatment?"
          onConfirm={handleDeleteConfirm}
          onCancel={() => setSubDeleteCandidate(null)}
        />
      )}
    </div>
  );
};
